import { useContext, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { Box, Button, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";

const NewReport = ({ open, onClose, onCreateReport }) => {
    const [reportType, setReportType] = useState("html");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleDialogClose = () => {
        setFromDate("");
        setToDate("");
        setReportType("html");
        onClose();
    };

    const handleCreateReport = () => {
        onCreateReport(fromDate, toDate, reportType);
        handleDialogClose();
    };

    return (
        <Box display="flex" flexDirection="column" height="100vh">
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={onClose}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
                    <Typography fontSize={18} fontWeight={600} ml={1}>{t('createStatementReport')}</Typography>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", px: 3, py: 3 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <Box>
                        <Typography variant="body2" sx={{ mb: 1 }}>{t('fromDate')}</Typography>
                        <TextField type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ mb: 1 }}>{t('toDate')}</Typography>
                        <TextField type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                    </Box>
                    <FormControl component="fieldset">
                        <Typography variant="body2" sx={{ mb: 1 }}>{t('reportType')}</Typography>
                        <RadioGroup row value={reportType} onChange={(e) => setReportType(e.target.value)}>
                            <FormControlLabel value="html" control={<Radio />} label={t('html')} />
                            <FormControlLabel value="pdf" control={<Radio />} label={t('pdf')} />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>
            <Box sx={{ p: 2 }}>
                <Button variant="contained" color="primary" fullWidth sx={{ borderRadius: 2 }} onClick={handleCreateReport}>{t('report')}</Button>
            </Box>
        </Box>
    );
};

export default NewReport